// Extremely subtle, self-contained ambient pad (Web Audio API).
// Deliberately minimal: a slow, quiet chord pad only — no beats, no arpeggio,
// no bass pulse, no drops. Volume is kept far below the voice-over so narration
// stays crystal clear. Music is OFF by default in the player.
const CHORDS = [
  [261.63, 329.63, 392.0], // C major
  [293.66, 349.23, 440.0], // D minor
  [261.63, 349.23, 440.0], // F/C
  [246.94, 329.63, 392.0], // E minor-ish
];

export class MusicEngine {
  constructor() {
    this.ctx = null;
    this.playing = false;
    this.enabled = true;
    this.step = 0;
    this.chordTimer = null;
    this.padOscs = [];
  }

  _ensure() {
    if (this.ctx) return;
    const AC = window.AudioContext || window.webkitAudioContext;
    this.ctx = new AC();

    this.master = this.ctx.createGain();
    this.master.gain.value = 0.0001;
    this.master.connect(this.ctx.destination);

    // Gentle low-passed pad, very low level
    this.padGain = this.ctx.createGain();
    this.padGain.gain.value = 0.03; // barely audible
    const lp = this.ctx.createBiquadFilter();
    lp.type = "lowpass";
    lp.frequency.value = 900;
    this.padGain.connect(lp);
    lp.connect(this.master);

    this.padOscs = CHORDS[0].map((f) => {
      const o = this.ctx.createOscillator();
      o.type = "sine";
      o.frequency.value = f;
      o.connect(this.padGain);
      o.start();
      return o;
    });
  }

  _applyChord(i) {
    const c = CHORDS[i % CHORDS.length];
    const t = this.ctx.currentTime;
    this.padOscs.forEach((o, idx) => o.frequency.setTargetAtTime(c[idx], t, 1.2));
  }

  start() {
    this._ensure();
    if (this.ctx.state === "suspended") this.ctx.resume();
    const t = this.ctx.currentTime;
    this.master.gain.cancelScheduledValues(t);
    this.master.gain.setValueAtTime(Math.max(this.master.gain.value, 0.0001), t);
    this.master.gain.linearRampToValueAtTime(this.enabled ? 0.5 : 0.0001, t + 2.0);
    if (this.playing) return;
    this.playing = true;
    this._applyChord(0);
    this.chordTimer = setInterval(() => {
      this.step += 1;
      this._applyChord(this.step);
    }, 8000); // slow, calm changes
  }

  pause() {
    if (!this.ctx) return;
    const t = this.ctx.currentTime;
    this.master.gain.cancelScheduledValues(t);
    this.master.gain.linearRampToValueAtTime(0.0001, t + 0.6);
    clearInterval(this.chordTimer);
    this.chordTimer = null;
    this.playing = false;
  }

  setEnabled(v) {
    this.enabled = v;
    if (!this.ctx) return;
    const t = this.ctx.currentTime;
    this.master.gain.cancelScheduledValues(t);
    this.master.gain.linearRampToValueAtTime(v && this.playing ? 0.5 : 0.0001, t + 0.4);
  }

  dispose() {
    this.pause();
    if (this.ctx) this.ctx.close();
    this.ctx = null;
  }
}
